import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";

import Home from "@/pages/Home";
import CommonNumber from "@/pages/CommonNumber";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import DreamNumber from "@/pages/DreamNumber";
import PreviousResult from "@/pages/PreviousResult";
import ResultHistory from "@/pages/ResultHistory";
import TeerCalendar from "@/pages/TeerCalendar";
import Analysis from "@/pages/Analysis";
import PredictTarget from "@/pages/PredictTarget";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import { AdminLayout } from "@/pages/admin/AdminLayout";
import AdminTodayResult from "@/pages/admin/AdminTodayResult";
import AdminPreviousResults from "@/pages/admin/AdminPreviousResults";
import AdminChangePassword from "@/pages/admin/AdminChangePassword";

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if (hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, search, hash]);

  return null;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-center" richColors />
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/common-number" element={<CommonNumber />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogPost />} />
            <Route path="/dream-number" element={<DreamNumber />} />
            <Route path="/previous-result" element={<PreviousResult />} />
            <Route path="/result-history" element={<ResultHistory />} />
            <Route path="/calendar" element={<TeerCalendar />} />
            <Route path="/analysis" element={<Analysis />} />
            <Route path="/predict-target" element={<PredictTarget />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<AdminTodayResult />} />
              <Route path="previous" element={<AdminPreviousResults />} />
              <Route path="password" element={<AdminChangePassword />} />
            </Route>

            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
